import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {ParamService} from './param.service';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UcaNavigationService {
    banner = this.paramService.banner;
    populateUcaNavigationSource$ = new BehaviorSubject(null);

    constructor(
        private paramService: ParamService,
        private http: HttpClient) {
    }

    getApplicationDomainURL() {
        let domain;
        if (window.location.href.indexOf('local') > 0) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + window.location.host;
        }
        return domain;
    }

    async checkUrlStatus(url: string): Promise<boolean> {
        try {
            const response = await fetch(url, { method: 'GET' });

            if (response.status === 404) {
                return true;
            } else if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }
            return false;
        } catch (error) {
            console.error("Error checking URL:", error);
            return true; // Consider network errors as 404 for simplicity, or handle differently
        }
    }

    async getLeftNavItems(banner, currentEnvironment) {
        const rand = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
        let navigationURL :  any;
        let checkURL = this.getApplicationDomainURL() + environment[currentEnvironment].leftNavigation; + '?rand=' + rand;
        checkURL = checkURL.replace(/\{banner\}/g, this.banner);
        const is404 = await this.checkUrlStatus(checkURL);
        if(is404) {
            navigationURL = this.getApplicationDomainURL() + environment[currentEnvironment].leftNavigation + '?rand=' + rand;
            navigationURL = navigationURL.replace(/\{banner\}/g, 'master');
        } else {
            navigationURL = this.getApplicationDomainURL() + environment[currentEnvironment].leftNavigation + '?rand=' + rand;
            navigationURL = navigationURL.replace(/\{banner\}/g, this.banner);
        }
        this.http.get(`${navigationURL}`).subscribe((response: any) => {
                if (response) {
                    this.populateUcaNavigationSource$.next(response);
                }
            },
            error => {
                console.log('Error while fetching navigation from UCA');
            });
    }


}
